<template>
  <label class="select-hour" :for="`select-${this._uid}`">
    <span v-if="!taskHours" class="mck">R</span>
    <select
      :id="`select-${this._uid}`"
      :value="value"
      @change="$emit('input', $event.target.value), $emit('change')"
      :disabled="disabled"
    >
      <option v-if="value" :value="value">{{ value }}</option>
      <option :value="null">-</option>
      <option v-for="h in filteredHours" :key="`h-${h}`" :value="h">
        {{ h }}
      </option>
    </select>
  </label>
</template>

<script>
import hours from "../mixins/hours.js";
export default {
  mixins: [hours],
  props: [
    "value",
    "disabled",
    "filters",
    "start",
    "end",
    "taskHours",
    "taskHoursFirst", // remove 00:00 from every hour except the first one in a task
    "skipFirst", // Just skipping the first hour. Use only for second hour selector of a period
  ],
  computed: {
    filteredHours() {
      let start = this.start ? this.hours.indexOf(this.start) : 0;
      let end = this.end ? this.hours.indexOf(this.end) : this.hours.length;

      let hours = this.hours.slice();
      let hide = [];

      if (this.filters) {
        for (let f of this.filters) {
          const from = f.from ? hours.indexOf(f.from) : 0;
          const to = f.to ? hours.indexOf(f.to) : hours.length;

          for (let i = from + 1; i <= to - 1; i++) {
            hide.push(i);
          }
        }
      }

      if (hide.length) {
        hide.sort((a, b) => a - b);
        hide = [...new Set(hide)];
      }

      // for overlaping periods
      if (!this.taskHours && hide.length) {
        if (this.start) {
          const x = this.hours.indexOf(this.start);
          let i = hide.filter((h) => h > x);
          i = i[0];

          if (typeof i === "number") end = i;
        } else if (this.end) {
          const x = this.hours.indexOf(this.end);
          let i = hide.filter((h) => h < x);
          i = i[i.length - 1];

          if (typeof i === "number") start = i;
        }
      }

      hours = hours.filter((h, i) => {
        return (
          (this.skipFirst ? i > start : i >= start) &&
          i < end &&
          hide.indexOf(i) < 0
        );
      });

      if (this.taskHours && !this.taskHoursFirst) {
        if (hours[0] === "00:00") hours.splice(0, 1);
      }

      return hours;
    },
  },
};
</script>

<style scoped>
.select-hour {
  align-items: center;
  background-color: #e8e8e8;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  height: 20px;
  justify-content: center;
  margin: 1px 2px;
  padding: 0 10px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
  white-space: nowrap;
}
.select-hour:hover {
  background-color: #dbdada;
}
.select-hour select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: transparent;
  border: 0;
  color: #737373;
  cursor: pointer;
}
.select-hour .mck {
  color: #e65100;
  margin-right: 10px;
}
</style>